import React from "react";

import { useDeviceType } from "@lululemon/ecom-site/src/util/with-device-characteristics";
import {
  trackEvent,
  EVENT_CATEGORY,
  EVENT_TYPE,
} from "@lululemon/mwa-analytics";

import { CTABlock } from "@lululemon/pdp-ee-components/src";

/**
 * An adapter for managing data & state for `CTABlock` component.
 * It should not take *any* product data props.
 *
 * @example
 * <CTABlockAdapter />
 */
export default function CTABlockAdapter() {
  const {
    deviceType: { isMobile, isTablet },
  } = useDeviceType();

  const variant = isMobile || isTablet ? "mobile" : "desktop";
  const handleClick = () =>
    trackEvent(EVENT_CATEGORY.COMPONENT_EVENT, {
      eventSubType: EVENT_TYPE.INTERACTION,
      component: {
        id: "digital-educator-cta",
        type: "webCtaBlock",
        text: "Questions? Bring them on (all of them)",
        position: 2,
        totalCount: 2,
      },
    });

  return <CTABlock variant={variant} handleClick={handleClick} />;
}
